<template>
  <el-aside :class="[menu.collapse ? '' : 'aside-uncollapse']" :width="menu.collapse ? '88px' : '220px'">
    <Tabs class="tab-switch" v-model="activeTab" v-if="!$store.state.menu.collapse && !param.only">
      <el-tab-pane
        :label="$t('dashboard-bi::board-management::公共看板')"
        name="1"
        :disabled="!$auth('data-board-customer::show-list')"
      ></el-tab-pane>
      <el-tab-pane :label="$t('dashboard-bi::board-management::个人看板')" name="2"></el-tab-pane>
    </Tabs>
    <div class="collapse-switch" v-show="$store.state.menu.collapse">
      <div class="switch-wrapper">
        <div class="switch-dot" :class="activeTab == '2' ? 'change' : ''" @click="changeSwitch">
          <span>
            {{ collapseName }}
          </span>
        </div>
      </div>
    </div>
    <ScrollsBar :style="{ height: $store.state.menu.collapse ? '100%' : '' }" class="menuList">
      <template v-if="!boardMenuLoading">
        <div class="aside-padding" v-if="newMenus.length">
          <div class="menu-box">
            <el-menu
              :collapse="menu.collapse"
              :collapse-transition="false"
              :default-active="defaultRoute"
              @select="handleSelect"
              active-text-color="#0560fd"
              background-color="#fafbff"
              text-color="#5E6471"
              unique-opened
            >
              <template v-for="menuData in newMenus">
                <my-menu-item :item="menuData" :key="menuData.name" :translate="key => $t(key)"></my-menu-item>
              </template>
            </el-menu>
          </div>
        </div>
        <ZDefaultData
          :custom="{
            text: $t('system::common::text::board_empty'),
            buttons: emptyButton,
          }"
          class="menu-empty"
          v-else-if="!$store.state.menu.collapse"
        ></ZDefaultData>
      </template>
      <template v-else>
        <div style="height: 200px" v-loading="true"></div>
      </template>
    </ScrollsBar>
    <div
      :class="{ 'collapse-menu-button': $store.state.menu.collapse }"
      class="menu-button-group"
      v-show="!param.only && (showBoardHandle || !disabled)"
    >
      <!-- 判断按钮权限 -->
      <template v-if="showBoardHandle && !$store.state.menu.collapse">
        <el-button-group
          style="flex: 1"
          :class="[!!disabled ? 'no-menu' : '']"
          v-if="activeTab === '1' ? $auth('data-board-customer::addMenu') : true"
        >
          <el-tooltip
            :content="$t('system::common::btn::新增目录/菜单')"
            class="item"
            effect="dark"
            placement="top-start"
          >
            <el-button
              @click="visible = true"
              class="menu-button"
              plain
              size="medium"
              style="width: 50%"
              type="info"
              v-if="activeTab === '1' ? $auth('data-board-customer::addMenu') : true"
            >
              <!-- <i class="iconfont iconadd2s"></i> -->
              <img :src="icon.add" style="width: 24px; display: inline-block" />
            </el-button>
          </el-tooltip>
          <el-tooltip :content="$t('system::common::btn::菜单管理')" class="item" effect="dark" placement="top-start">
            <el-button @click="toSetting" class="menu-button" plain size="medium" style="width: 50%" type="info">
              <!-- <i class="iconfont icona-04kanban"></i> -->
              <img :src="icon.board" style="width: 24px; display: inline-block" />
            </el-button>
          </el-tooltip>
        </el-button-group>
        <el-tooltip
          v-else
          :content="$t('system::common::btn::菜单管理')"
          class="item"
          effect="dark"
          placement="top-start"
        >
          <el-button @click="toSetting" class="menu-button" plain size="medium" style="flex: 1" type="info">
            <!-- <i class="iconfont icona-04kanban"></i> -->
            <img :src="icon.board" style="width: 24px; display: inline-block" />
          </el-button>
        </el-tooltip>
      </template>

      <HandleMenu :menuList="handleMenuList" :showBoardHandle="showBoardHandle" v-show="!disabled"></HandleMenu>
    </div>
    <div
      class="combo-wrap"
      v-if="!menu.collapse && user.combo.isTrial && user.combo.isTrial === 1 && !user.isExpired && !user.combo.isThird"
    >
      <div class="combo-title">
        <p class="one-line">{{ user.combo.comboName }}</p>
        <span>{{ $t('personal::common::试用版') }}</span>
      </div>
      <div class="combo-date">
        <div class="combo-day">
          <p style="font-size: 36px" v-if="user.combo.comboExpireDay > 0">
            {{ user.combo.comboExpireDay }}
            <span>{{ $t('personal::common::天') }}</span>
          </p>
          <span v-else>{{ $t('personal::common::今天到期') }}</span>
        </div>
        <a @click="buyNow" class="combo-buy">{{ $t('personal::common::立即购买') }}</a>
      </div>
    </div>
    <AddOrUpdate :editRow="{ type: 'add' }" :routerType="Number(activeTab)" v-model="visible"></AddOrUpdate>
  </el-aside>
</template>
<script>
import { mapState } from 'vuex'
import Cookies from 'js-cookie'
import { _local } from '@/utils/storage'
import MyMenuItem from './menu-item-functional'
import AddOrUpdate from '@/views/dashboard/board-management/compoents/addOrUpdate.vue'
import { personalMenu, personalRouter } from './personal-menu'
import HandleMenu from './handle-menu.vue'
import ZDefaultData from '@/components/common/default-data/main'
import { toPersonalPage } from '@/utils/index'
import Tabs from '@/components/tabs'
export default {
  components: {
    MyMenuItem,
    AddOrUpdate,
    HandleMenu,
    ZDefaultData,
    Tabs,
  },
  props: {
    param: {
      default: () => ({
        only: false, // 是否只展示list数组
        list: [], // 菜单name数组
      }),
    },
  },
  data() {
    return {
      activeTab: '1',
      visible: false,
      personalMenu,
      icon: {
        board: require('@/assets/images/layout/board.png'),
        add: require('@/assets/images/layout/add.png'),
      },
      collapseName: '公',
    }
  },
  mounted() {
    // this.getMenu()
    if (
      !this.$auth('data-board-customer::show-list') ||
      (!this.boardMenu.platform.length && this.boardMenu.personal.length)
    ) {
      this.activeTab = '2'
    }
    if (this.user.combo.isTrial && this.user.combo.isTrial === 1 && !this.user.isExpired && !this.user.combo.isThird) {
      const h = this.$createElement
      const that = this
      this.$message({
        type: 'warning',
        message: h('p', null, [
          h(
            'span',
            {
              style: {
                color: '#f9bd01',
              },
            },
            that.$t('personal::common::trial', {
              day: that.user.combo.comboExpireDay,
              date: that.user.combo.comboExpireDateTime,
            })
          ),
          h(
            'a',
            {
              on: {
                click: () => that.buyNow(),
              },
              style: {
                color: '#ff4d00',
                marginLeft: '5px',
                textDecoration: 'underline',
              },
            },
            that.$t('personal::common::立享优惠')
          ),
        ]),
      })
    }
  },
  computed: {
    ...mapState(['menu', 'user']),
    boardMenuLoading() {
      return this.menu.boardMenuLoading
    },
    defaultRoute() {
      // 空白看板和第三方链接则判断ID
      if (this.$route.name === 'data-board' || this.$route.name === 'iframe-board') {
        return this.$route.query.actionId
      } else {
        // 排除个人中心列表
        // if (!personalRouter.includes(this.$route.name.split('::')[0])) {
        //   const obj = this.user.authorityList.find(item => item.actionCode.split('::').pop() == this.$route.name)
        //   if (obj && obj.actionId) {
        //     return this.$route.name + '::' + obj.actionId
        //   }
        // }
        if (this.$route.meta && this.$route.meta.parentsName) {
          return this.$route.meta.parentsName
        }
        return this.$route.path
      }
    },
    boardMenu() {
      return this.$store.state.menu.boardMenu
    },
    newMenus() {
      if (this.param.only) {
        //TODO 个人中心菜单，如果是域账号则不给购买套餐
        return this.$preAccount ? personalMenu.slice(1) : personalMenu
      } else {
        const list = this.$store.state.menu.boardMenu
        return this.activeTab === '1' ? list.platform : list.personal
      }
    },
    showBoardHandle() {
      // 判断看板设置权限，个人中心则不需要权限控制
      return this.activeTab === '1' ? this.$auth('data-board-customer::board-setting') : true
    },
    emptyButton() {
      if (this.activeTab === '1') {
        if (this.$auth('data-board-customer::board-setting') && this.$auth('data-board-customer::addMenu')) {
          return [{ type: 'text', text: $t('system::common::btn::立即新增'), btnClick: this.toNew }]
        } else {
          return []
        }
      } else {
        return [{ type: 'text', text: $t('system::common::btn::立即新增'), btnClick: this.toNew }]
      }
    },
    disabled() {
      // 判断是否有功能性菜单，如果没有则隐藏按钮
      let flag = this.handleMenuList.filter(menu => {
        return menu.children && menu.children.length
          ? menu.children.every(el => (el.children ? !!el.children.length : false))
          : false
      })
      return !flag.length
    },
    handleMenuList() {
      const parent = this.menu.menus.find(item => item.actionCode === 'shop-management' && item.actionType === 1)
      // TODO 暂时只取这两个目录下的菜单，只有这两个才有4级菜单
      // const menu =
      //   parent && parent.children
      //     ? parent.children.filter(
      //         el => el.actionCode.includes('system-setting') || el.actionCode.includes('work-data')
      //       )
      //     : []
      const menu =
        parent && parent.children ? parent.children.filter(el => el.actionCode.includes('system-setting')) : []
      return menu
    },
  },
  watch: {
    activeTab(val) {
      setTimeout(() => {
        this.collapseName =
          val == '1' ? $t('dashboard-bi::board-management::公') : $t('dashboard-bi::board-management::个')
      }, 300)
    },
  },
  methods: {
    changeSwitch() {
      // 无公共看板权限则不可切换
      if (!this.$auth('data-board-customer::show-list')) {
        return
      }
      if (this.activeTab === '1') {
        this.activeTab = '2'
      } else {
        this.activeTab = '1'
      }
    },
    toSetting() {
      if (this.activeTab === '1') {
        this.$router.push('/board-center-setting')
      } else {
        this.$router.push('/personal-board-setting')
      }
    },
    toNew() {
      this.toSetting()
      this.visible = true
    },
    handleSelect(index, indexPath) {
      // console.log(index, indexPath)
      // this.$router.push({ name: index.split("::")[0] })
    },
    buyNow() {
      _local.set('backUrl', this.$route.name === 'expired' ? window.location.origin : window.location.href)
      // this.$router.push(this.$preAccount ? '/my-account' : '/open-contract')
      toPersonalPage()
    },
  },
}
</script>

<style lang="scss" scoped>
.tab-switch {
  /deep/.el-tabs__header {
    margin: 0;
    padding: 30px 20px 24px 20px;
    .el-tabs__nav {
      padding: 0px;
    }
    .el-tabs__active-bar {
      width: 88px !important;
      border-radius: 8px;
      left: 0;
      background-color: #fff;
      z-index: 0;
      height: 42px;
      top: 1px;
    }
  }

  /deep/ .el-tabs__item {
    line-height: 44px;
    min-width: 88px;
    position: relative;
    width: 50%;
    z-index: 1;
    padding: 0 16px !important;
    height: 44px;
    &:hover {
      color: #010517;
      opacity: 0.65;
    }
    &.is-active {
      color: #010517;
      opacity: 1;
    }
    &.is-disabled {
      color: #010517;
      opacity: 0.2 !important;
      &:hover {
        opacity: 0.2 !important;
      }
    }
  }
  /deep/ .el-tabs__nav-scroll {
    padding: 0;
    border-radius: 8px;

    box-sizing: border-box;
    background-color: #edeff6;
  }
  /deep/ .el-tabs__nav-wrap::after {
    display: none;
  }
}
.collapse-switch {
  padding: 24px 10px 0;
  .switch-wrapper {
    width: 70px;
    height: 44px;
    border-radius: 22px;
    background: #eceff6;
    display: flex;
    align-items: center;
    .switch-dot {
      transition: transform 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
      cursor: pointer;
      margin: 0 2px;
      width: 40px;
      height: 40px;
      border-radius: 20px;
      background: #fff;
      display: flex;
      align-items: center;
      justify-content: center;
      span {
        font-weight: 600;
        color: #010517;
      }
    }
    .change {
      transform: translateX(calc(70px - 44px));
    }
  }
}
.menuList {
  flex: 1;
  box-sizing: border-box;
  padding: 0 18px;
  padding-top: 20px;
  /deep/ .default-empty-data {
    background: inherit !important;
  }
}
.el-aside {
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
.el-aside:not(.aside-uncollapse) {
  display: flex;
  flex-direction: column;
  overflow: hidden;

  .el-menu--collapse {
    width: 48px;
  }
  /deep/ .el-submenu {
    border-radius: 8px;
    height: 48px;
    position: relative;
    &.is-active {
      z-index: 2;
      box-shadow: 0px 10px 15px -8px rgba(5, 96, 253, 0.37);
      .el-submenu__title {
        background-color: #0560fd !important;

        border-radius: 8px;
        &:hover {
          background-color: #0560fd !important;
        }
        i {
          color: #fff !important;
        }
      }
    }
  }

  .el-submenu {
    border-radius: 8px;
    ::v-deep {
      .el-menu {
        border-radius: 0 0 8px 8px;
        background-color: inherit !important;
      }

      .el-submenu__title {
        font-weight: bold;
        height: 48px;
        line-height: 48px;
        border-radius: 8px;
        i {
          color: #737f95;
          font-weight: normal;
        }
        &:hover {
          border-radius: 8px;
          background-color: #e5e9ee !important;
        }
      }

      .el-menu-item {
        font-weight: normal;
        i {
          color: #010517;
          // color: #5e6471;
        }
        &:hover {
          border-radius: 8px;
          background-color: #e5e9ee !important;
        }
        &.is-active {
          i {
            background-color: #0560fd !important;
            color: #fff !important;
          }
        }

        &:last-child {
          border-bottom-left-radius: 8px;

          border-bottom-right-radius: 8px;
          &:hover {
            border-top-left-radius: 0px !important;
            border-top-right-radius: 0px !important;
          }
        }
      }

      .el-submenu__icon-arrow {
        right: 8px;
      }
    }
  }
}
.el-aside.aside-uncollapse {
  .menuList {
    padding-top: 0px;
  }
  .h-menu-title {
    display: none;
    display: inline-block;
    color: #010517;
  }

  .el-menu {
    // padding-top: 20px;
    & > .el-menu-item {
      height: 48px;
      box-sizing: border-box;
      color: #010517 !important;
      min-width: auto;
      i {
        color: #010517;
      }
      font-weight: bold;
      line-height: 48px;
      padding-left: 20px !important;
      padding-right: 20px !important;
      &:hover {
        border-radius: 8px;
        background-color: #e5e9ee !important;
      }
    }
    .el-submenu {
      border-radius: 8px;
      ::v-deep {
        .el-menu {
          border-radius: 0 0 8px 8px;
          background-color: inherit !important;
        }
        .el-submenu__title {
          font-weight: bold;
          border-radius: 8px;
          i {
            // color: #5e6471;
            color: #010517;
            font-weight: normal;
          }
          &:hover {
            border-radius: 8px;
            background-color: #e5e9ee !important;
          }
        }

        .el-menu-item {
          font-weight: normal;
          i {
            color: #010517;
            // color: #5e6471;
          }
          &:hover {
            border-radius: 8px;
            background-color: #e5e9ee !important;
          }
          &.is-active {
            i {
              background-color: #e5e9ee !important;
              color: #0560fd !important;
            }
          }

          &:last-child {
            border-bottom-left-radius: 8px;

            border-bottom-right-radius: 8px;
            &:hover {
              border-top-left-radius: 0px !important;
              border-top-right-radius: 0px !important;
            }
          }
        }

        .el-submenu__icon-arrow {
          right: 8px;
        }
      }
      &.is-opened {
        .el-menu-item {
          &:hover {
            border-radius: 0px !important;
            background-color: #e5e9ee !important;
          }
          &.is-active {
            i {
              color: #0560fd !important;
            }
          }

          &:last-child {
            border-bottom-left-radius: 8px;
            border-bottom-right-radius: 8px;
            &:hover {
              border-top-left-radius: 0px !important;
              border-top-right-radius: 0px !important;
              border-bottom-left-radius: 8px !important;
              border-bottom-right-radius: 8px !important;
            }
          }
        }
      }
    }
  }

  .el-menu-item {
    &.is-active {
      .h-menu-title {
        color: #0560fd !important;
      }
    }
    &:hover {
      border-radius: 8px;
      background-color: #e5e9ee !important;
    }
  }
  .combo-wrap {
    width: 100%;
    height: 90px;
    background: url('../../assets/combo-bg.png') 100% 100%;
    padding: 13px 24px;
    box-sizing: border-box;
    .combo-title {
      display: flex;
      align-items: center;
      font-size: 14px;
      color: #fff;
      p {
        max-width: 140px;
      }
      span {
        display: inline-block;
        margin-left: 5px;
        font-size: 12px;
        background: #fff;
        color: #0560fd;
        padding: 2px 4px;
        border-radius: 2px;
        white-space: nowrap;
      }
    }
    .combo-date {
      margin-top: 6px;
      display: flex;
      justify-content: space-between;
      align-items: flex-end;
      .combo-day {
        font-size: 26px;
        color: #fff;
        font-weight: bold;
        flex: 1;
        span {
          margin-left: 5px;
          font-size: 14px;
        }
      }
      .combo-buy {
        color: #fff;
        position: relative;
        top: -8px;
        text-decoration: underline;
        white-space: nowrap;
      }
    }
  }
}
.menu-box {
  .el-menu {
    padding: 0;
  }
}
.el-aside.aside-uncollapse {
  .menu-box {
    width: 100%;
    padding-bottom: 20px;
  }
}

.logo {
  line-height: 80px;
  text-align: center;
  color: #fff;
  font-size: 30px;
}

.site-wrapper-menu {
  left: 30px !important;
  max-height: 250px;
  overflow-y: auto;
  .el-dropdown-menu__item {
    &.active {
      background-color: #eef0ff;
      color: #7687ff;
    }
  }
  .add-icon {
    font-size: $--base-icon-size;
    margin-right: $--sm-margin;
  }
  ::v-deep {
    .popper__arrow {
      display: none;
    }
  }
}
.site-name {
  width: 100%;
  height: 32px;
  line-height: 32px;
  font-size: 14px;
  // padding: 0 20px;
  margin-bottom: 20px;
  box-sizing: border-box;
  color: #9da1c3;
  display: flex;
  justify-content: space-between;
  .copy-shop-btn {
    box-sizing: border-box;
    height: 28px;
    color: #9da1c3;
    border: 1px solid #9da1c3;
    padding: 0 20px;
    &:hover {
      color: #fff;
      border: 1px solid #fff;
    }
  }
}
::v-deep {
  .el-menu--collapse {
    .el-menu-item {
      .el-tooltip {
        text-align: center;
      }
    }
    .h-menu-title {
      margin-right: 0 !important;
    }
  }
}

.menu-icon {
  cursor: pointer;
  color: #9da1c3;
  outline: none;
  font-size: 12px;
  position: relative;
  top: -1px;
  transition: transform 0.3s;
  margin-left: 18px;
  display: inline-block;
  &.arrow {
    transform: rotateZ(180deg);
  }
}
.shop-container {
  max-height: 500px;
  overflow: auto;
  width: 220px;
  .shop-item {
    padding: 8px 12px;
    position: relative;
    padding-right: 32px;
    // overflow: hidden;
    cursor: pointer;
    .shop-action {
      position: absolute;
      top: 8px;
      right: 20px;
      .iconfont {
        font-size: 14px;
        color: #4054ff;
        cursor: pointer;
        margin-left: 3px;
      }
    }

    &.active {
      background: #f5f7fa;
      cursor: not-allowed;
    }
    &:hover {
      background: #f5f7fa;
    }
    &:after {
      position: absolute;
      content: '';
      width: 208px;
      height: 1px;
      background-color: #dcdfe6;
      bottom: 0;
    }
    &:last-child {
      &:after {
        display: none;
      }
    }
  }

  .shop-name {
    line-height: 21px;
    margin-bottom: 2px;
  }
  .shop-id,
  .shop-domain {
    font-size: 12px;
    line-height: 16px;
    color: #9da1c3;
  }
}
.add-item {
  padding: 16px 12px;
  text-align: center;
  width: 100%;
  box-sizing: border-box;
}
.el-aside {
  .logo-container {
    background-color: #161b3f;
    border-bottom: 1px solid #3b4377;
    padding: 16px 0;
    margin-bottom: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    img {
      width: 35px;
      height: 35px;
    }
  }
}
.site-info {
  flex: 1;
  position: relative;
  margin-left: 8px;
  padding-right: 40px;
  text-align: left;
  &__name {
    font-size: 14px;
  }
  &__id {
    font-size: 12px;
    line-height: 16px;
    color: #9da1c3;
    background-color: #465095;
    padding: 0 6px;
    display: inline-flex;
  }
  .iconfont {
    position: absolute;
    right: 26px;
    &:hover {
      color: #fff;
    }
  }
}

.el-aside.aside-uncollapse {
  // padding: 30px;

  .logo-container {
    padding-left: 10px;
    font-size: 20px;
    color: #fff;
    text-align: center;
    img {
      width: 60%;
      height: auto;
      margin-left: 0;
    }
  }
  .el-menu {
    .el-submenu {
      ::v-deep {
        .el-icon-arrow-down {
          display: none;
        }
        .el-submenu__title {
          border-radius: 8px;
          line-height: 48px;
          height: 48px;
          background-color: inherit !important;
          padding-left: 14px !important;
          padding-right: 14px !important;
          font-weight: bold;
          justify-content: flex-start;
          i {
            color: #737f95;
            font-weight: normal;
          }
          &:hover {
            border-radius: 8px;
            background-color: #e5e9ee !important;
          }
        }

        .el-menu-item {
          background-color: inherit !important;
          i {
            color: #737f95;
          }
          &:hover {
            border-radius: 8px;
            background-color: #e5e9ee !important;
          }
        }

        .el-submenu__icon-arrow {
          right: 8px;
        }
      }
      &.is-active {
        .el-submenu__title {
          i {
            color: #0560fd !important;
          }
        }
      }
      .el-menu-item {
        .iconfont {
          display: none;
        }
        height: 48px;

        color: #010517 !important;
        padding-left: 56px !important;
        text-align: left;
        line-height: 48px;
        .h-menu-title {
          color: #676974;
        }
      }
    }
  }
}

.el-menu {
  border-right: none;
  ::v-deep {
    .el-submenu__title {
      // 按钮和文字对齐问题
      display: flex;
      align-items: center;
      justify-content: center;
    }
    > .el-menu-item {
      height: 48px;
      line-height: 48px;
    }
    [class^='el-icon-'],
    [class^='iconfont'] {
      margin-right: 18px;
      font-size: 24px;
      display: inline-block;
      width: 24px;
    }
  }
}
.iconlogo,
.iconsmall {
  color: #fff !important;
  font-size: 40px;
}

.site-popper {
  margin-left: 0 !important;
  padding: 0 !important;
  .popper__arrow {
    display: none !important;
  }
}
.menu-button-group {
  padding: 24px 20px;
  flex: 0 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .collapse-menu-button {
    justify-content: center !important;
  }
  .el-button-group > .el-button {
    border-radius: 8px;
  }
  .el-button-group > .el-button:first-child {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }
  .el-button-group > .el-button:last-child {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }
  .el-button-group {
    width: 120px !important;
    &.no-menu {
      width: 100% !important;
    }
    flex: 0 0 auto !important;
    white-space: nowrap;
  }
  .menu-button {
    border: 0px;
    height: 48px;
    display: flex;
    align-items: center;
    justify-content: center;
    &.self-btn {
      width: 54px;
    }
  }

  .menu-button + .menu-button {
    border-left: 1px solid #e7eaed;
  }
}

.menu-empty {
  padding: 80px 20px;
  /deep/ .img {
    margin-bottom: 10px;
    width: 94px !important;
  }
  /deep/ span {
    font-size: 12px !important;
  }
}
/deep/ .el-button--info.is-plain:hover,
.el-button--info.is-plain:focus {
  background: #eaecef;
  border-color: #eaecef;
}
/deep/ .el-button--primary.is-plain:hover,
.el-button--primary.is-plain:focus {
  background: #ebf0ff;
  border-color: #afc5ff;
}
</style>
